import React from 'react';
import { Card, CardContent } from './ui/card';
import { benefits } from '../data/mock';
import { Award, Shield, TrendingUp, BadgeCheck, ShoppingBag, Globe } from 'lucide-react';

const iconMap = {
  Award,
  Shield,
  TrendingUp,
  BadgeCheck,
  ShoppingBag,
  Globe
};

export const BenefitsSection = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-emerald-50 to-amber-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-emerald-900 mb-4">
            Benefits of Trademark Registration
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Federal trademark registration provides powerful legal protection and valuable business advantages that go far beyond simple name protection.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12 max-w-7xl mx-auto">
          {benefits.map((benefit, index) => {
            const Icon = iconMap[benefit.icon];
            return (
              <Card
                key={index}
                className="border-2 border-emerald-200 hover:shadow-2xl transition-all duration-300 hover:border-amber-500 hover:-translate-y-2"
              >
                <CardContent className="p-8 h-full flex flex-col">
                  <div className="bg-gradient-to-br from-emerald-700 to-emerald-600 w-20 h-20 rounded-full flex items-center justify-center mb-6 shadow-lg">
                    <Icon className="h-10 w-10 text-white" />
                  </div>
                  <h3 className="text-2xl font-bold text-emerald-900 mb-4">
                    {benefit.title}
                  </h3>
                  <p className="text-gray-700 leading-relaxed text-base flex-grow">
                    {benefit.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Additional Benefits Section */}
        <div className="max-w-5xl mx-auto">
          <Card className="bg-white border-2 border-emerald-200 shadow-2xl">
            <CardContent className="p-8 md:p-12">
              <div className="grid md:grid-cols-2 gap-8 items-center">
                <div>
                  <img
                    src="https://images.unsplash.com/photo-1460925895917-afdab827c52f"
                    alt="Business analytics showing trademark value growth"
                    className="rounded-xl shadow-lg w-full h-80 object-cover"
                  />
                </div>
                <div className="flex flex-col justify-center">
                  <h3 className="text-3xl font-bold text-emerald-900 mb-6">
                    Building Long-Term Brand Equity
                  </h3>
                  <p className="text-gray-700 leading-relaxed mb-4 text-base">
                    A registered trademark is more than just legal protection—it's a valuable business asset that appreciates over time. Companies with strong trademark portfolios command higher valuations, attract better investors, and enjoy greater market confidence.
                  </p>
                  <p className="text-gray-700 leading-relaxed text-base">
                    Federal registration signals to customers, partners, and competitors that you're serious about your brand. The ® symbol builds credibility and trust, giving you a competitive edge in crowded markets. As your business grows, your registered trademark becomes increasingly valuable, often representing one of your company's most important assets.
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};
